module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/apprenticeCurious-3e7236cce83cb89c2edaeb8503ed9211.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/apprenticeCurious.png
// module id = 2430
// module chunks = 2